import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'

Vue.filter('verifyEmail', async (email) => {
    let result = await axios({
        method: 'get',
        maxBodyLength: Infinity,
        url: 'https://api.usebouncer.com/v1.1/email/verify?email=' + email,
        headers: { 'X-API-KEY': 'LB5Mvl0Xefy6uFhBhFGTVtiz6JA66e15Q2DWS5Jk' }
    })

    return result.data.status === 'deliverable' || result.data.status === 'risky' || result.data.status === 'unknown'
})

Vue.filter('dateFormatter', (date, format = 'MMM D, YYYY') => {
	
	if (!date) return '--'

    return moment(date).format(format)
})

Vue.filter('capitalize', function (value) {
	if (!value) return ''
	value = value.toString()
	return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('dateTime', (val, format, parsing) => {
	return moment(val, parsing).format(format)
})

Vue.filter('null', function (value) {
	if (!value) return '-'
	else return value
})

Vue.filter('time', function (time, format) {
	return moment(time, format).format('LT')
})

Vue.filter('isPostDate', function (date) {
	return moment() > moment(date)
})


export default Vue
